module.exports = __webpack_public_path__ + "img/logo-5.46af85c9.svg";